module.exports = __webpack_public_path__ + "img/stream_error.e8df826e.svg";